import * as React from "react";
import apiClients from "../../apiClients";
import * as Messages from "../../codegen/Messages";
import { parseId } from "../../helpers/idHelper";
import { useMutationCall } from "../../hooks/useMutationCall";
import {
  ADBS_DELETE_POLL_DELAY,
  ADBS_DELETE_POLL_INTERVAL,
  AsyncNotificationMethodKey,
  AsyncNotificationPolledResponseKey,
} from "../../models/AsyncNotificationProviders";
import { getOciRegion } from "../../utils";
import { OperationConfirmationProps } from "../OperationTypes";

export interface AdbsDeleteProps extends OperationConfirmationProps {
  databaseId: string | undefined;
}

const AdbsDelete = (
  { location, databaseId, onExecute }: AdbsDeleteProps,
): JSX.Element => {
  const { invokeCall: deleteAdbs } = useMutationCall(
    { method: apiClients.withRegion(getOciRegion(location)).adbsDatabaseApi.deleteAdbsDatabase },
  );

  React.useEffect(() => {
    const { subscriptionId, resourceGroup, resourceName } = parseId(databaseId);
    const resGroup = decodeURIComponent(resourceGroup || "");
    const resName = decodeURIComponent(resourceName || "");

    const invokeOptions = {
      onSuccess: onExecute,
      notification: {
        inProgress: {
          title: Messages.notifications.inProgress.titles.deleteAdbs(),
          message: Messages.notifications.inProgress.messages.deleteAdbs(resName),
        },
        success: {
          title: Messages.notifications.success.titles.deleteAdbs(),
          message: Messages.notifications.success.messages.deleteAdbs(resName),
        },
        failure: {
          title: Messages.notifications.failure.titles.delete(),
          message: Messages.notifications.failure.messages.deleteAdbs(resName),
        },
        asyncPolling: {
          methodKey: AsyncNotificationMethodKey.ADBS_GET,
          methodArgs: {
            subscriptionId,
            resourceGroupName: resGroup,
            databaseName: resName,
          },
          location,
          responseMethodKey: AsyncNotificationPolledResponseKey.ADBS_DELETED_CHECK,
          errorStatusOverrides: [404],
          delay: ADBS_DELETE_POLL_DELAY,
          interval: ADBS_DELETE_POLL_INTERVAL,
        },
      },
    };

    deleteAdbs({
      subscriptionId,
      resourceGroupName: resGroup,
      databaseName: resName,
    }, invokeOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div />;
};

export const newAdbsDelete = (
  props: AdbsDeleteProps,
): JSX.Element => (<AdbsDelete {...props} />);
